export const POPUP_DURATION = 5000;
export const MAXIMUM_NOTIFICATION_POPUPS = 3; 